<div class="license-item">
  <div class="license-item__top">
    <div *ngIf="item?.licenseName?.value" class="license-item__name">
      {{ item.licenseName.value }}
    </div>
  </div>
  <div
    class="license-item__bottom"
    [class.license-item__bottom--last]="isLast"
    [class.license-item__bottom--first]="isFirst"
  >
    <div *ngIf="item?.pricePerMonth?.value" class="license-item__price">
      <div class="license-item__price-per-month">
        <strong>{{
          item.pricePerMonth.value | mask : "separator" : "."
        }}</strong>
        <div class="license-item__price-currency">
          {{ "licensePanel.Item.Price.Currency" | translate }}
          <span>{{ "licensePanel.Item.Price.PerMonth" | translate }}</span>
        </div>
      </div>
      <div
        *ngIf="item?.pricePerYear?.value"
        class="license-item__price-per-year"
      >
        ({{ item.pricePerYear.value | mask : "separator" : "." }}
        {{ "licensePanel.Item.Price.PerYear" | translate }})
      </div>
    </div>
    <div class="license-item__action">
      <a
        *ngIf="item?.link?.value"
        [href]="item.link.value.url"
        [target]="item.link.value.target || '_self'"
        class="license-item__link"
        >{{ item.link.value.name }}</a
      >
    </div>
  </div>
</div>
